import { render, staticRenderFns } from "./MNSOFlagPopUp.vue?vue&type=template&id=556ef86c"
import script from "./MNSOFlagPopUp.vue?vue&type=script&lang=js"
export * from "./MNSOFlagPopUp.vue?vue&type=script&lang=js"
import style0 from "./MNSOFlagPopUp.vue?vue&type=style&index=0&id=556ef86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports